<template>
  <div class="xer-flex xer-flex-col xer-items-center">
    <xer-automation-sync-point value="Oeps" />

    <img
      v-if="rootStore.lang === 'fr'"
      :src="getPictogramUrl('oups')"
      alt="icon_oups"
      class="xer-mb-8 xer-h-13"
    />
    <img v-else :src="getPictogramUrl('oeps')" alt="icon_oeps" class="xer-mb-8 xer-h-13" />

    <div class="xer-mb-9 xer-flex xer-flex-col xer-items-center">
      <h1 class="xer-heading-xl xer-pb-4" v-html="label" />
      <p v-html="beschrijving" />
    </div>
    <div class="xer-text-s" v-html="aanvraagId" />
  </div>
</template>

<script>
import getPictogramUrl from '@/utils/get-pictogram-url';
import XerAutomationSyncPoint from '@/components/XerAutomationSyncPoint';
import applicationInsights from '@/application-insights';
import { mapStores } from 'pinia';
import { useRootStore } from '@/stores';

export default {
  name: 'XerOeps',
  components: {
    XerAutomationSyncPoint
  },
  computed: {
    ...mapStores(useRootStore),
    label() {
      const labelKey = 'Moez.Error.Label';
      const translatedLabel = this.rootStore.translate(labelKey);
      if (labelKey === translatedLabel) {
        return 'Oeps, er is iets misgegaan.';
      }
      return translatedLabel;
    },
    beschrijving() {
      const beschrijvingKey = 'Moez.Error.Beschrijving';
      const translatedBeschrijving = this.rootStore.translate(beschrijvingKey);
      if (beschrijvingKey === translatedBeschrijving) {
        return 'Je probeert best nog eens opnieuw.';
      }
      return translatedBeschrijving;
    },
    aanvraagId() {
      return this.$route.query?.aanvraagId;
    }
  },
  mounted() {
    applicationInsights.trackPageView('Xerius - Oeps', 'Oeps', 'XerOeps');
  },
  methods: {
    getPictogramUrl
  }
};
</script>
